"use client";

import Analytics from "@/app/_components/analytics";
import { Layout } from "@/components";
import { GamePageLayout } from "@/components/NewGamePage/GamePageLayout";
import { ImageBackground } from "@/components/ui/custom/image-background";
import { useFeatureFlags } from "@/hooks/useFeatureFlags";
import { GameDetailsProvider } from "../../../../context/GameDetailsContext";
import GameDetailsV2 from "../game-details-v2";
import type { GameData } from "../types";

export const SubscribedLayout = ({ gameData }: { gameData: GameData }) => {
  const { newGamePageNov25Gpt, introVideoExperimentNov25Gpt } =
    useFeatureFlags();

  if (newGamePageNov25Gpt === undefined) return null;

  if (newGamePageNov25Gpt && gameData.gameContent?.is_prelaunch) {
    return (
      <Layout disableContainerPadding hideRightNav>
        <GameDetailsProvider gameData={gameData}>
          <GamePageLayout
            gameData={gameData}
            introVideoExperimentNov25Gpt={introVideoExperimentNov25Gpt}
          />
        </GameDetailsProvider>
      </Layout>
    );
  }

  return (
    <Layout disableContainerPadding>
      {!!gameData.details.background_url && (
        <ImageBackground
          staticImageUrl={gameData.details.background_url}
          className="absolute inset-0"
        />
      )}
      <Analytics screen="Details" userJourney="Games" />
      <GameDetailsV2 gameData={gameData} />
    </Layout>
  );
};
